let result;
let dotNetInstance;

let options = {
    childList: true,
    subtree: true
};

window.AutoFitClient = window.AutoFitClient ?? {};

window.AutoFitClient.fitObserver = window.AutoFitClient.fitObserver ?? {};

window.AutoFitClient = {
    setup: () => {
        window.AutoFitClient.fitObserver = new MutationObserver(function () {
            return dotNetInstance.reference?.invokeMethodAsync("AutoFitAllColumns");
        });
    },
    observeTarget: (dotNetObj, gridClass) => {
        result = document.querySelector(`.${gridClass} .k-grid-table:first-of-type`);
        dotNetInstance = dotNetObj;

        if (!result || !dotNetInstance) {
            window.setTimeout(window.AutoFitClient.observeTarget, 500);
            return;
        }
    
        window.AutoFitClient.fitObserver.observe(result, options);

        if (dotNetInstance) {
            dotNetInstance.reference?.invokeMethodAsync("AutoFitAllColumns");
            window.AutoFitClient.fitObserver.disconnect();
        }
    },
    hasWhiteSpace: () => {
        const grid = document.querySelector(".k-grid");
        const gridTable = document.querySelector(".k-grid-table");

        return grid?.offsetWidth > gridTable?.offsetWidth;
    }
}